import React from 'react';
import { Row } from 'react-bootstrap';
import AudioPlayer from 'components/audio/AudioPlayerQA';
import { CallScoreCard } from 'pages/hvaqualityassurance/CallScorecards';
import { CallOpenQuestion } from 'pages/hvaqualityassurance/CallOpenQuestions';

// Definición del tipo de los props que el componente recibirá
interface CallQAControlProps {
  selectedcallid: string;
  selectedcampaignid: number;
  selectedcustomer: string;
  selecteddateyphone: string;
  selectedfilename: string;
}

const CallQAControl: React.FC<CallQAControlProps> = ({
  selectedcallid,
  selectedcampaignid,
  selectedcustomer,
  selecteddateyphone,
  selectedfilename
}) => {
  return (
    <div>
      <div className="bg-body-emphasis px-4 px-lg-6 pe-0 pe-lg-0">
        <AudioPlayer
          callid={selectedcallid || ''}
          campaignid={selectedcampaignid}
          customer={selectedcustomer || ''}
          phone={selecteddateyphone || ''}
          audioSrc={selectedfilename}
        />
      </div>
      <div className="border-top">
        <div className="px-4 px-lg-6 pt-2 pb-3">
          <Row>
            <CallScoreCard
              callid={selectedcallid || ''}
              campaignid={selectedcampaignid}
            />
          </Row>
          <Row>
            <CallOpenQuestion
              callid={selectedcallid || ''}
              campaignid={selectedcampaignid}
            />
          </Row>
        </div>
      </div>
    </div>
  );
};

export default CallQAControl;
